// extracted by mini-css-extract-plugin
module.exports =  {"label":"_93444fe79c--label--hIfaq","cursor_pointer":"_93444fe79c--cursor_pointer--Pe1mY"};